import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minuteSeconds'
})
export class MinuteSecondsPipe implements PipeTransform {

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    const sec = Math.floor(value - Math.ceil(minutes * 60));
    if ((minutes != 0 && sec == 0)) {
      return minutes + ' min';
    } else if ((minutes != 0 && sec != 0)) {
      return minutes + ' min ' + sec + ' sec';
    } else if ((minutes == 0 && sec != 0) || (minutes == 0 && sec == 0)) {
      return sec + ' sec';
    }
    return minutes + ' min ' + sec + ' sec';
  }

}